module.exports = __webpack_public_path__ + "img/thumb_up_&_thumb_down.4746328e.svg";